// extracted by mini-css-extract-plugin
module.exports = {"container":"rich-text-highlight_container__4cV7T","link":"rich-text-highlight_link__3gQ9s","svg":"rich-text-highlight_svg__kgUgN"};